var cloneDeep = require('lodash/cloneDeep');
var defaultConfig = require('./stubs/defaultConfig.stub.js');
module.exports = cloneDeep(defaultConfig.theme);